import { Dispatch } from "../../utility/common/storeHelper"
import { workshopActions } from "./slice"
import { push } from "connected-react-router"
import { getMockedCatalog } from "../../utility/tests/mockedObjects/workshop"
import { ApplicationEditType } from "../../models/workshop/template"

export const resetWorkshopState = () => (dispatch: Dispatch) => {
    dispatch(workshopActions.setApplicationTemplateCreating(false))
    dispatch(workshopActions.setCurrentApplicationTemplate(undefined))
    dispatch(workshopActions.setCurrentApplicationTemplateVersion(undefined))
    dispatch(workshopActions.setCurrentTempCategory(undefined))
    dispatch(workshopActions.setCurrentApplicationTemplateVersionId(""))
    dispatch(workshopActions.setEditMode(false))
    dispatch(workshopActions.deletePublishedVersion())
    dispatch(workshopActions.setQueryString(""))
}

export const finishCreatingApplicationTemplate = (lastTemplateId: string) => (dispatch: Dispatch) => {
    dispatch(workshopActions.deleteApplicationTemplate(lastTemplateId))
    dispatch(workshopActions.setCurrentApplicationTemplate(undefined))
    dispatch(workshopActions.setCurrentTempCategory(undefined))
    dispatch(workshopActions.setApplicationTemplateCreating(false))
    dispatch(workshopActions.setEditMode(false))
}

export const createEmptyApplicationTemplate = (projectId: string) => (dispatch: Dispatch) => {
    const catalog = getMockedCatalog()
    const category = catalog[0]

    dispatch(workshopActions.addApplicationTemplateCategory(category))
    dispatch(workshopActions.setCurrentTempCategory(category))
    dispatch(workshopActions.setCurrentApplicationTemplate(undefined))
    dispatch(workshopActions.setCurrentApplicationTemplateVersionId(category.Versions[0].Id))
    dispatch(workshopActions.setApplicationTemplateCreating(true))
    dispatch(goToCreatePage(projectId))
}

export const createBasePath = (projectId: string) => `/project/${projectId}/workshop`

export const goToCreatePage = (projectId: string) => (dispatch: Dispatch) => {
    const basePath = createBasePath(projectId)
    dispatch(push(`${basePath}/create`))
}

export const goToHomePage = (projectId: string) => (dispatch: Dispatch) => {
    dispatch(push(createBasePath(projectId)))
}

export const goToViewPage = (projectId: string, viewType: ApplicationEditType, id: string) => (dispatch: Dispatch) => {
    const basePath = createBasePath(projectId)
    dispatch(push(`${basePath}/${viewType}/${id}`))
}
